import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";
import { parseNum } from "@/lib/shop";
import { Spinner } from "@/components/ProtectedRoute";

export default function AdminShipping() {
  const [rows, setRows] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/shipping").then(({ data }) => setRows(data.map((m) => ({ ...m, cost: String(m.cost), max_weight_g: String(m.max_weight_g) }))));
  }, []);

  if (!rows) return <Spinner />;
  const set = (id, k, v) => setRows(rows.map((r) => (r.id === id ? { ...r, [k]: v } : r)));

  const save = async () => {
    const body = rows.map((r) => ({ id: r.id, cost: parseNum(r.cost), max_weight_g: parseInt(r.max_weight_g, 10), enabled: r.enabled }));
    if (body.some((b) => !(b.cost >= 0) || !(b.max_weight_g > 0))) return toast.error("Controlla costi e pesi");
    setSaving(true);
    try {
      await api.put("/admin/shipping", body);
      toast.success("Spedizioni aggiornate");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-3">
      {rows.map((r) => (
        <div key={r.id} data-testid={`admin-shipping-row-${r.id}`} className="card-mc grid grid-cols-2 items-end gap-3 p-4 sm:grid-cols-[1fr_130px_150px_auto]">
          <div className="col-span-2 sm:col-span-1">
            <div className="font-bold">{r.name}</div>
            <div className="text-xs text-muted-foreground">{r.zone === "IT" ? "Italia" : "Estero"} · {r.description}</div>
          </div>
          <label className="space-y-1 text-xs font-bold uppercase text-muted-foreground">Costo (€)
            <Input data-testid={`admin-shipping-cost-${r.id}`} inputMode="decimal" value={r.cost} onChange={(e) => set(r.id, "cost", e.target.value)} className="h-10 text-foreground" />
          </label>
          <label className="space-y-1 text-xs font-bold uppercase text-muted-foreground">Peso max (g)
            <Input data-testid={`admin-shipping-weight-${r.id}`} inputMode="numeric" value={r.max_weight_g} onChange={(e) => set(r.id, "max_weight_g", e.target.value)} className="h-10 text-foreground" />
          </label>
          <label className="col-span-2 flex items-center gap-2 pb-2 text-sm font-semibold sm:col-span-1">
            <Switch data-testid={`admin-shipping-enabled-${r.id}`} checked={r.enabled} onCheckedChange={(v) => set(r.id, "enabled", v)} /> Attivo
          </label>
        </div>
      ))}
      <button data-testid="admin-save-shipping-button" className="btn-mc" disabled={saving} onClick={save}>
        {saving && <Loader2 className="h-4 w-4 animate-spin" />} Salva spedizioni
      </button>
    </div>
  );
}
